import log from 'loglevel';
import { ApiService } from "./ApiService";
import { TokenRequiredStrategy } from "../strategies/TokenRequiredStrategy";
import { ApiEndpoints } from '@/constants/ApiEndpoints';




import { User } from "@/interfaces/User";
import { ContactUs } from "@/interfaces/ContactUs";
import { DeleteAccount } from "@/interfaces/DeleteAccount";
import { SuccessResponse } from "@/interfaces/SuccessResponse";
import { UpdateUserParams } from "@/interfaces/UpdateUserParams";
import { MyReferralResponse } from "@/interfaces/MyReferralResponse";
import { VerifyPhoneNumberInput } from "@/interfaces/InHouseTasks/VerifyPhoneNumberInput";





class UserServiceClass extends ApiService {




    private USER_ENDPOINT = ApiEndpoints.USER;
    private MY_REFERRALS = ApiEndpoints.MY_REFERRALS;
    private CONTACT_US_ENDPOINT = ApiEndpoints.CONTACT_US;
    private DELETE_ACCOUNT_ENDPOINT = ApiEndpoints.DELETE_ACCOUNT;
    private UPDATE_PHONE_NUMBER_ENDPOINT = ApiEndpoints.UPDATE_PHONE_NUMBER;
    private OFFER_WALL_CLICK_COUNT_ENDPOINT = ApiEndpoints.OFFER_WALL_CLICK_COUNT;




    constructor() {
        super(TokenRequiredStrategy)
    }




    async getUser(): Promise<User> {
        try {
            return await this.get(this.USER_ENDPOINT)
        } catch (error) {
            log.error('Failed to fetch user:', error);
            throw error;
        }
    }



    
    async getMyReferrals(): Promise<MyReferralResponse> {
        try {
            const response = await this.get(this.MY_REFERRALS);
            return response;
        } catch (error) {
            log.error('Failed to fetch my referrals:', error);
            throw error;
        }
    }

    async contactUsDetails(data: ContactUs): Promise<SuccessResponse> {
        try {
            const result = await this.post(this.CONTACT_US_ENDPOINT, data)
            return result;
        } catch (error) {
            log.error('Failed to initiate payout:', error);
            throw error;
        }
    }

    async deleteUserAccount(data: DeleteAccount): Promise<SuccessResponse> {
        try {
            const result = await this.post(this.DELETE_ACCOUNT_ENDPOINT, data)
            return result;
        } catch (error) {
            log.error('Failed to initiate payout:', error);
            throw error;
        }
    }

    async updateUserPhoneNumber(data: VerifyPhoneNumberInput) {
        try {
            return await this.put(this.UPDATE_PHONE_NUMBER_ENDPOINT, data)
        } catch (error) {
            log.error('Failed to update phone number:', error);
            throw error;
        }
    }


    async updateUserPaypalEmail(data: UpdateUserParams) {
        try {
            return await this.put(this.USER_ENDPOINT, data)
        } catch (error) {
            log.error('Failed to update paypal email:', error);
            throw error;
        }
    }

    async updateOfferWallClickCount(data: object) {
        try {
            return await this.post(this.OFFER_WALL_CLICK_COUNT_ENDPOINT, data)
        } catch (error) {
            log.error('Failed to set click count:', error);
            throw error;
        }
    }
}

const UserService = new UserServiceClass();
export { UserService };
